var map = {
	"./fi": 409,
	"./fi.js": 409
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 972;



/*****************
 ** WEBPACK FOOTER
 ** ./~/moment/locale fi
 ** module id = 972
 ** module chunks = 0
 **/